import { observer } from 'mobx-react';
import * as React from 'react';
import { TranslationsContext } from '@teliaee/telia-translate';
import BranchOpenTime from './BranchOpenTime';
import { BusinessHour } from '../common/ReservationInterfaces';

interface BranchBusinessHoursProps {
  businessHours: BusinessHour[];
}

@observer
class BranchBusinessHours extends React.Component<BranchBusinessHoursProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const { businessHours } = this.props;

    return (
      <>
        {businessHours &&
          businessHours.map((hour, index) => {
            const margin = index === 0 ? 'text__margin' : 'text__margin-half';
            return (
              <p key={index} className={margin}>
                {translate(`branch.openDay_${hour.startDay}`)}
                {hour.startDay !== hour.endDay && <span>–{translate(`branch.openDay_${hour.endDay}`)}</span>}
                <BranchOpenTime hour={hour} displayOpenText={false} />
              </p>
            );
          })}
      </>
    );
  }
}

export default BranchBusinessHours;
